import { all, fork } from 'typed-redux-saga';
import apiSaga from './api/apiSaga';
import cartSaga from './cart-and-place-order/cartSaga';
import cartTrackingSaga from './cart-orders-tracking/cartTrackingSaga';
import contactSaga from './contact/contactSaga';
import sessionDataTrackingSaga from './session-data-tracking/sessionDataTrackingSaga';
import sessionSaga from './session/sessionSaga';
import watchAuthChangesSaga from '@spa/lib/store/sagas/auth/watchAuthChangesSaga';
import wishlistSaga from '@spa/lib/store/sagas/wishlist/wishlistSaga';

function* saga(): Generator {
  yield* all([
    fork(cartTrackingSaga),
    fork(apiSaga),
    fork(cartSaga),
    fork(contactSaga),
    fork(sessionSaga),
    fork(watchAuthChangesSaga),
    fork(sessionDataTrackingSaga),
    fork(wishlistSaga)
  ]);
}

export default saga;
